import { TrackingEventLabels as BaseTrackingEventLabels } from '../../common/tracking/tracking-event-labels.model';

export const TrackingEventLabels = {
  ...BaseTrackingEventLabels
};
